<template>
  <div class="">
    <div class="flex h-screen">
      <div class="hidden md:block w-0 md:w-1/2 side_bg_img">
        <div class="w-[80%] h-[70vh] m-auto text-white">
          <div class="pt-[16px]">
            <!-- <h2 class="mt-4 text-[35px] font-bold">Grow Wealth</h2> -->
            <h2 class="text-[35px] font-bold mt-32">Grow Wealth</h2>
            <p class="text-white text-xs w-fit py-1 rounded-full">
              Trusted by over 2,000,000 people like
              <span class="text-[#8dc63f]">you!</span>
            </p>
            <p class="pt-4 text-xs">
              “You get the absolute best choosing <br />
              ACCESS as your preferred PFA”
            </p>
          </div>
        </div>
      </div>

      <Login
        :onIndemintyModalOpen="onIndemintyModalOpen"
        v-if="showLoginForm === 0"
        :showLoginForm="showLoginForm"
        :toggleLoginForm="toggleLoginForm"
        class="relative overflow-auto"
      />

      <ForgotRegister
        v-if="showLoginForm === 1"
        :showLoginForm="showLoginForm"
        :toggleLoginForm="toggleLoginForm"
        class="overflow-auto"
      />

      <!-- they are not same but they use to be same -->
      <Register
        v-if="showLoginForm === 2"
        :showLoginForm="showLoginForm"
        :toggleLoginForm="toggleLoginForm"
        class="overflow-auto"
      />
    </div>

    <IndemnityModal
      :isIndemnityModalOpen="isIndemnityModalOpen"
      :onIndemintyModalOpen="onIndemintyModalOpen"
    />
  </div>
</template>

<script>
import { computed, reactive } from "vue";
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import ForgotRegister from "@/components/forgotRegister.vue";
import Register from "@/components/Register.vue";
import Login from "@/components/Login.vue";
import IndemnityModal from "@/components/modals/indemnityModal";
import accessLogo from "@/assets/AccessLogo.png";
export default {
  components: {
    ForgotRegister,
    Login,
    IndemnityModal,
    Register,
  },
  setup() {
    const showLoginForm = ref(0);
    const isIndemnityOpen = ref(false);
    const store = useStore();
    console.log(showLoginForm.value, "show");

    const state = reactive({
      password: "",
      identifier: "",
      code: "",
      check: false,
    });

    const isIndemnityModalOpen = computed(() => isIndemnityOpen.value);

    const onIndemintyModalOpen = () => {
      isIndemnityOpen.value = !isIndemnityOpen.value;
    };

    const toggleLoginForm = (value) => {
      showLoginForm.value = value;

      store.dispatch("getActionName", value);
    };

    return {
      showLoginForm,
      toggleLoginForm,
      state,
      isIndemnityModalOpen,
      isIndemnityOpen,
      onIndemintyModalOpen,
      accessLogo,
    };
  },
};
</script>

<style scoped>
.side_bg_img {
  background-image: url("../../assets/EmployerPortalLogo.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
}

.field-icon {
  float: right;
  margin-left: -25px;
  margin-top: -27px;
  position: relative;
  z-index: 2;
  margin-right: 15px;
}

.fade-enter {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 500ms ease-out;
}

.fade-leave-to {
  opacity: 0;
}
</style>
